import React from 'react'
import { Frame, StandardRatios } from '@hub/frame'
import { Image as ChakraImage } from '@chakra-ui/image'
import {
  As,
  HubStyleObject,
  HubResponsiveValue,
  StandardSizes,
  forwardRef,
} from '@hub/design-system-base'

interface ImageProps {
  as?: As
  sx?: HubStyleObject
  src?: string
  description?: string
  minWidth?: HubResponsiveValue<StandardSizes>
  maxWidth?: HubResponsiveValue<StandardSizes>
  ratio?: HubResponsiveValue<StandardRatios>
}

export const Image = forwardRef<ImageProps, typeof Frame>(
  ({ as, sx, src, description, minWidth, maxWidth, ratio = 1 }, ref) => (
    <Frame
      ref={ref}
      as={as}
      ratio={ratio}
      minWidth={minWidth}
      maxWidth={maxWidth}
      sx={sx}
    >
      <ChakraImage src={src} alt={description} boxSize="size-full" />
    </Frame>
  )
)
